export const ITEM_DETAIL_REQUEST = 'ITEM_DETAIL_REQUEST'
export const GET_EXPENDITURE = 'GET_EXPENDITURE'
export const SET_EXPENDITURE = 'SET_EXPENDITURE'
export const GET_ORDER_DETAIL = 'GET_ORDER_DETAIL'
export const SET_ORDER_DETAIL = 'SET_ORDER_DETAIL'
export const SET_REQUEST_OPTION = 'SET_REQUEST_OPTION'

export const SET_APPROVAL_ORDER_REQUEST = 'SET_APPROVAL_ORDER_REQUEST'

export const SET_IS_ORDER_APPROVAL_COMPLETE = 'SET_IS_ORDER_APPROVAL_COMPLETE'
export const SUBMIT_ORDER_APPROVAL_REQUEST = 'SUBMIT_ORDER_APPROVAL_REQUEST'

export const SET_GRID_COLUMNS = 'SET_GRID_COLUMNS'
export const SET_ORDERS_STATUS = 'SET_ORDERS_STATUS'
export const GET_ORDERS_STATUS = 'GET_ORDERS_STATUS'

export const GET_FLEET_PROCESSING_GRID_DATA = 'GET_FLEET_PROCESSING_GRID_DATA'
export const SET_FLEET_PROCESSING_GRID_DATA = 'SET_FLEET_PROCESSING_GRID_DATA'

export const SET_IS_ORDER_CANCELED = 'SET_IS_ORDER_CANCELED'
export const CANCEL_ORDER_REQUEST = 'CANCEL_ORDER_REQUEST'

export const GET_ACTION_POPUP_VALUE = 'GET_ACTION_POPUP_VALUE'

export const SET_PENDING_ORDERS_GRID_DATA = 'SET_PENDING_ORDERS_GRID_DATA'
export const GET_PENDING_ORDERS_GRID_DATA = 'GET_PENDING_ORDERS_GRID_DATA'

export const SET_MY_ORDERS_GRID_DATA = 'SET_MY_ORDERS_GRID_DATA'
export const GET_MY_ORDERS_GRID_DATA = 'GET_MY_ORDERS_GRID_DATA'

export const GET_GRID_ORDERS_COUNT = 'GET_GRID_ORDERS_COUNT'
export const SET_GRID_ORDERS_COUNT = 'SET_GRID_ORDERS_COUNT'

export const SET_ALL_PENDING_ORDERS_GRID_DATA = 'SET_ALL_PENDING_ORDERS_GRID_DATA'
export const GET_ALL_PENDING_ORDERS_GRID_DATA = 'GET_ALL_PENDING_ORDERS_GRID_DATA'

export const IS_GRID_DATA_LOADING = 'IS_GRID_DATA_LOADING'
export const IS_GRID_COUNTS_LOADING = 'IS_GRID_COUNTS_LOADING'
